type createNonCollapsablePageRoutesArgsType = {
  remotes: { path?: string; nonCollapsableRoutes?: RegExp[] | [] }[];
};

const createNonCollapsablePageRoutes = ({ remotes }: createNonCollapsablePageRoutesArgsType) => {
  const nonCollapsableRoutesList: RegExp[] = [];
  remotes.forEach(remote => {
    if (remote?.nonCollapsableRoutes) {
      let { nonCollapsableRoutes } = remote;

      if (nonCollapsableRoutes.length) {
        nonCollapsableRoutesList.push(...nonCollapsableRoutes);
      }
    }
  });

  return nonCollapsableRoutesList;
};

export default createNonCollapsablePageRoutes;
